export default {
	post_type_archive_partners() { import('./post_type_archive_partners'); },
}
